export enum EmploymentTerms {
  ProbationPeriod = "PROBATION_PERIOD",
  VacationDays = "VACATION_DAYS",
  SickDays = "SICK_DAYS",
  ParentalLeave = "PARENTAL_LEAVE",
  TerminationNotice = "TERMINATION_NOTICE",
  Benefits = "BENEFITS",
  Allowance = "ALLOWANCE",
}
